import { SCREENS } from '../services/exports/Constants';
import useScreenType from '../hooks/utility/useScreenType';
import { useTranslation } from 'react-i18next';
import useRouter from '../hooks/navigation/useRouter';
import classnames from 'classnames';
import useMobileApp from '../hooks/mobile-app/useMobileApp';
import PageHeader from '../components-library/headers/PageHeader';
import OrderBasket from '../components-library/order-basket';

interface Props {
  customParentContainer?: string;
  customParentStyle?: object;
}

export default function OrderBasketScreen(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Pages:OrderBasketScreen' });

  const { customParentContainer, customParentStyle } = props;

  const { isDesktop } = useScreenType();
  const { navigate } = useRouter();
  const { isMobileApp } = useMobileApp();
  const hasCheckoutNavBar = !isMobileApp && !isDesktop;

  return (
    <div
      className={classnames('lg:h-screen h-full flex flex-col relative overflow-hidden', customParentContainer)}
      style={customParentStyle}
    >
      {hasCheckoutNavBar && (
        <PageHeader.Back
          onClick={() =>
            navigate({
              web: { to: SCREENS.HOME_SCREEN },
            })
          }
          title={t('buttons.menu')}
        />
      )}
      <OrderBasket />
    </div>
  );
}
